import React from 'react';

export const PermissionDenied: React.FC = () => {
  return <h1>Permission Denied</h1>;
};
